import { ServiceTokens } from "$src/domain/ServiceTokens";
import { DocumentSummary } from "$src/domain/projects/documents/DocumentSummary";
import type { IDocumentRepository } from "$src/domain/projects/documents/IDocumentRepository";
import { BlobResult } from "$src/infrastructure/network/BlobResult";
import { inject, injectable } from "tsyringe";

@injectable()
export class GetDocumentById {
    
    constructor(@inject(ServiceTokens.DocumentRepository) private documentRepository: IDocumentRepository) {}

    async execute(groupStoreId: number, projectId: number, documentId: string): Promise<DocumentSummary> {
        var blobUrl = await this.documentRepository.getDocument(groupStoreId, projectId, documentId);
        return blobUrl;
    }
}

export const GetDocumentByIdToken = Symbol('GetDocumentByIdToken');    
